import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Button, Modal, Input, Divider, message, Upload} from "antd";
import Cookies from "js-cookie";
import { UploadOutlined } from "@ant-design/icons";

import { backendURL } from "../Globals";// 🔹 Cambia esto si el backend tiene otra URL

const Card = ({ name, href, logo, onDelete, showAdminPanel }) => {
  return (
    <div className="card-container">
      <a href={href} className="card" target="_blank" rel="noopener noreferrer">
        {logo ? (
          <img src={`${backendURL}/logos/${logo}`} alt={name} className="editor-logo" />
        ) : (
          <div className="card-content">{name}</div>
        )}
      </a>
      {showAdminPanel && (
        <button className="delete-button" onClick={onDelete}>🗑️ Eliminar</button>
      )}
    </div>
  );
};


const AboutComponent = () => {
  const location = useLocation();
  const [publishers, setPublishers] = useState([]);
  // 🔹 Estado para el nuevo editor
const [newPublisher, setNewPublisher] = useState({ name: "", href: "", logo: null });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);

  // 🔹 Estados para los textos editables
  const [introText, setIntroText] = useState("");
  const [biblioText, setBiblioText] = useState("");

  useEffect(() => {
    const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
    setIsLoggedIn(!!apiKey);

    // Obtener publishers
    axios.get(`${backendURL}/publishers`)
      .then(response => setPublishers(response.data))
      .catch(error => console.error("Error fetching publishers:", error));

    // Obtener los textos de about
    axios.get(`${backendURL}/about`)
      .then(response => {
        const intro = response.data.find(item => item.section_name === "intro");
        const biblio = response.data.find(item => item.section_name === "biblioguia");
        if (intro) setIntroText(intro.content);
        if (biblio) setBiblioText(biblio.content);
      })
      .catch(error => console.error("Error fetching about info:", error));
  }, [location.pathname]);
  const handleDelete = (id) => {
    Modal.confirm({
      title: "¿Estás seguro de eliminar este editor?",
      content: "Esta acción no se puede deshacer.",
      okText: "Sí, eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      onOk: async () => {
        const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");
        if (!apiKey) return;

        try {
          await axios.delete(`${backendURL}/publishers/${id}`, {
            headers: { Authorization: `Bearer ${apiKey}` }
          });
          setPublishers(publishers.filter(p => p.id !== id));
        } catch (error) {
          console.error("Error deleting publisher:", error);
        }
      }
    });
  };

  // 🔹 Manejar subida de imagen
const handleUpload = ({ file }) => {
  setNewPublisher({ ...newPublisher, logo: file });
};

// 🔹 Añadir un nuevo editor
const handleAddPublisher = async () => {
  if (!newPublisher.name || !newPublisher.href || !newPublisher.logo) {
    message.error("Todos los campos son obligatorios");
    return;
  }

  const formData = new FormData();
  formData.append("name", newPublisher.name);
  formData.append("href", newPublisher.href);
  formData.append("logo", newPublisher.logo);

  const apiKey = Cookies.get("apiKey") || localStorage.getItem("apiKey");

  try {
    const response = await axios.post(`${backendURL}/publishers`, formData, {
      headers: {
        Authorization: `Bearer ${apiKey}`,
        "Content-Type": "multipart/form-data"
      }
    });

    setPublishers([...publishers, response.data]); // Añadir a la lista
    message.success("Editor añadido correctamente");
    setNewPublisher({ name: "", href: "", logo: null }); // Reiniciar formulario
  } catch (error) {
    console.error("Error al añadir editor:", error);
    message.error("Error al añadir editor");
  }
};

  return (
    <div className="about-container">
      <h2 className="about-title">¿Qué son los Acuerdos Transformativos?</h2>
      <p className="about-text">
        Son los tradicionales contratos firmados por la biblioteca con las editoriales para acceder a grandes paquetes de revistas electrónicas, pero con nuevas condiciones: parte del dinero que se usaba solo para pagar la suscripción por leer se utiliza ahora para que las editoriales publiquen en acceso abierto publicaciones del personal investigador de la Universidad de Oviedo sin cobrar más por ello.
        En casi todos los acuerdos hay dos claves: anualmente se dispone de una cantidad limitada de APCs para usar y no entran todas las revistas del catálogo de las editoriales, sino solo una selección, que son las llamadas "revistas elegibles". La Biblioteca de la Universidad de Oviedo tiene firmados los siguientes acuerdos transformativos:
      </p>

      <div className="card-grid">
        {publishers.map(publisher => (
          <Card
            key={publisher.id}
            name={publisher.name}
            href={publisher.href}
            logo={publisher.logo_url} // 🔹 Ahora usa el logo del backend
            onDelete={() => handleDelete(publisher.id)}
            showAdminPanel={isLoggedIn && showAdminPanel}
          />
        ))}
      </div>

      {/* 🔹 Espaciado antes de la Biblioguía */}
      <div style={{ marginTop: "20px" }}>
        <p className="about-text">
          Consulta información ampliada sobre los acuerdos transformativos en nuestra{" "}
          <a href="https://uniovi.libguides.com/acuerdostransformativos" target="_blank" rel="noopener noreferrer">Biblioguía</a>.
        </p>
      </div>

      {/* 🔹 Mostrar botón para activar/desactivar administración */}
      {isLoggedIn && (
        <div style={{ marginTop: "30px" }}>
          {/* 🔹 Formulario para añadir un nuevo editor */}
{isLoggedIn && showAdminPanel && (
  <div className="add-publisher-form">
    <Divider />
    <h3>Añadir un nuevo editor</h3>
    <Input
      placeholder="Nombre del editor"
      value={newPublisher.name}
      onChange={(e) => setNewPublisher({ ...newPublisher, name: e.target.value })}
    />
    <Input
      placeholder="URL del editor"
      value={newPublisher.href}
      onChange={(e) => setNewPublisher({ ...newPublisher, href: e.target.value })}
    />
    <Upload beforeUpload={() => false} onChange={handleUpload} showUploadList={false}>
      <Button icon={<UploadOutlined />}>Subir logo</Button>
    </Upload>
    <Button type="primary" onClick={handleAddPublisher} style={{ marginTop: "10px" }}>
      Añadir Editor
    </Button>
  </div>
)}
          <Button type="dashed" onClick={() => setShowAdminPanel(!showAdminPanel)}>
            {showAdminPanel ? "Ocultar Administración" : "Administrar Editores"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AboutComponent;

